import { render, staticRenderFns } from "./AuthRegister.vue?vue&type=template&id=2321bc61&"
import script from "./AuthRegister.vue?vue&type=script&lang=js&"
export * from "./AuthRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2321bc61')) {
      api.createRecord('2321bc61', component.options)
    } else {
      api.reload('2321bc61', component.options)
    }
    module.hot.accept("./AuthRegister.vue?vue&type=template&id=2321bc61&", function () {
      api.rerender('2321bc61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthRegister.vue"
export default component.exports